import { render, staticRenderFns } from "./NguoiKy.vue?vue&type=template&id=01901b4a&scoped=true&"
import script from "./NguoiKy.vue?vue&type=script&lang=js&"
export * from "./NguoiKy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01901b4a",
  null
  
)

export default component.exports